// export const BaseUrl = 'http://localhost:63660/';
// export const BaseUrl = 'https://wsdhtest.tripleh.com.mx/';
  export const BaseUrl = 'https://wsdh.tripleh.com.mx/';